import React from "react";
import { reduxForm, Field } from "redux-form";
import { Button, Input } from "expano-components";
import { Modal } from "components";

const InputField = (props) => <Input {...props} />;

const EditFileNameModal = ({
  handleClose,
  handleSubmit,
  onSubmit,
  file_ext,
  pristine,
}) => {
  return (
    <Modal
      header={{
        title: "Zmiana nazwy pliku",
      }}
      footer={
        <>
          <Button type="button" text="Anuluj" onClick={handleClose} />
          <button
            disabled={pristine}
            type="button"
            style={{ width: 100, justifyContent: "center" }}
            className="btn btn-sm btn-green"
            onClick={handleSubmit}
          >
            <span>Zapisz</span>
          </button>
        </>
      }
      handleClose={handleClose}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          label="Nazwa pliku"
          component={InputField}
          name="file_name"
          postfix={`.${file_ext}`}
        />
      </form>
    </Modal>
  );
};

export default reduxForm({
  enableReinitialize: true,
})(EditFileNameModal);
